import { User, RequestUserParam } from '@/repositories/data'
import { Axios } from 'axios'

export interface UserRepository {
  list(companyKey: string): Promise<User[]>;
  adminList(companyKey: string): Promise<User[]>;
  get(companyKey: string, userKey: string): Promise<User>;
  add(companyKey: string, request: RequestUserParam): Promise<User>;
  modify(companyKey: string, userKey: string, request: RequestUserParam): Promise<User>;
  delete(companyKey: string, userKey: string): void;
  initializePassword(companyKey: string, userKey: string): void;
  sendWelcomeUser(companyKey: string, userKey: string): void;
  sendWelcomeAllUser(companyKey: string): void;
}

export class UserRepositoryImpl implements UserRepository {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios
  private readonly baseUrl = 'system/user'

  async list (companyKey: string): Promise<User[]> {
    const { data } = await this.http.get(`${this.baseUrl}/${companyKey}`)
    return data
  }

  async adminList (companyKey: string): Promise<User[]> {
    const { data } = await this.http.get(`${this.baseUrl}/admin/${companyKey}`)
    return data
  }

  async get (companyKey: string, userKey: string): Promise<User> {
    const { data } = await this.http.get(`${this.baseUrl}/${companyKey}/${userKey}`)
    return data
  }

  async add (companyKey: string, request: RequestUserParam): Promise<User> {
    const { data } = await this.http.post(`${this.baseUrl}/${companyKey}`, request)
    return data
  }

  async modify (companyKey: string, userKey: string, request: RequestUserParam): Promise<User> {
    const { data } = await this.http.put(`${this.baseUrl}/${companyKey}/${userKey}`, request)
    return data
  }

  async delete (companyKey: string, userKey: string) {
    await this.http.delete(`${this.baseUrl}/${companyKey}/${userKey}`)
  }

  async initializePassword (companyKey: string, userKey: string) {
    await this.http.post(`${this.baseUrl}/${companyKey}/${userKey}/initialize-password`)
  }

  async sendWelcomeUser (companyKey: string, userKey: string) {
    await this.http.post(`${this.baseUrl}/${companyKey}/${userKey}/send-welcome-user`)
  }

  async sendWelcomeAllUser (companyKey: string) {
    await this.http.post(`${this.baseUrl}/${companyKey}/send-welcome-all-user`)
  }
}
